function createCollapsible(el, initial = false) {
  let isOpen = initial;

  el.style.height = isOpen ? "auto" : "0";
  el.style.overflow = "hidden";

  function open() {
    if (isOpen) {
      return;
    }
    isOpen = true;

    const currentHeight = getComputedStyle(el).height;
    el.style.height = "auto";
    const height = getComputedStyle(el).height;
    el.style.height = currentHeight;
    getComputedStyle(el).height;
    requestAnimationFrame(function () {
      el.style.height = height;
    });
  }

  function close() {
    if (!isOpen) {
      return;
    }
    isOpen = false;

    const height = getComputedStyle(el).height;
    el.style.height = height;
    getComputedStyle(el).height;
    requestAnimationFrame(function () {
      el.style.height = "0";
    });
  }

  el.style.transition = "height 300ms ease-in-out";
  el.addEventListener("transitionend", function (e) {
    if (e.target !== el) {
      return;
    }
    if (isOpen) {
      el.style.height = "auto";
    }
  });

  return {
    open,
    close,
    el,
  };
}

function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

(function () {
  // DODANE: Globalna zmienna do zapamiętania quantity z OTP
  let savedOTPQuantity = 1;

  function updatePrice(el, value, moneyFormat) {
    if (el == null) {
      return;
    }
    return (el.innerHTML =
      '<span class="money">' + formatMoney(value, moneyFormat) + "</span>");
  }

  function getAllocatedSellingPlanById(variant, id) {
    return variant.sellingPlans.find((plan) => plan.id === Number(id));
  }

  function initSellingPlanInput(form) {
    let el = form.querySelector('input[name="selling_plan"]');

    if (!el) {
      el = document.createElement("input");
      el.type = "hidden";
      el.name = "selling_plan";
      form.append(el);
    }

    return el;
  }

  function setQuantity(quantity, sectionId) {
    const quantityForm = document.querySelector(`#Quantity-Form-${sectionId}`);
    if (!quantityForm) {
      console.warn("Quantity form not found");
      return;
    }

    const quantityInput = quantityForm.querySelector("input[name='quantity']");
    if (!quantityInput) {
      console.warn("Quantity input not found");
      return;
    }

    // Set value
    quantityInput.value = quantity;
    quantityInput.valueAsNumber = quantity;

    // Dispatch all necessary events
    quantityInput.dispatchEvent(new Event("input", { bubbles: true }));

    // Trigger quantity rules validation
    const quantityInputElement = quantityForm.querySelector("quantity-input");
    if (quantityInputElement && quantityInputElement.validateQtyRules) {
      quantityInputElement.validateQtyRules();
    }

    // Also update the custom Taio quantity input
    updateTaioQuantityInput(quantity);

    console.log("Quantity set to:", quantityInput.value);
  }

  function updateTaioQuantityInput(quantity) {
    const taioQuantityInput = document.querySelector(".taio-quantity-input");
    if (taioQuantityInput) {
      taioQuantityInput.value = quantity;
      taioQuantityInput.valueAsNumber = quantity;
      console.log("Taio quantity input updated to:", quantity);
    }
  }

  function updateButtonPrice(price, sectionId, moneyFormat) {
    console.log(
      "Updating button price for section:",
      sectionId,
      "Price:",
      price
    );

    // Try to ensure button price element exists
    const buttonPrice = ensureButtonPriceElement(sectionId, price, moneyFormat);

    if (buttonPrice) {
      buttonPrice.innerHTML = `<span>| </span>${formatMoney(
        price,
        moneyFormat
      )}`;
      console.log("Button price updated to:", buttonPrice.innerHTML);
    } else {
      console.log("Could not find or create button price element");
    }
  }

  function ensureButtonPriceElement(sectionId, price, moneyFormat) {
    // First try to find existing element
    let buttonPrice = document.querySelector(`#button-price-${sectionId}`);

    if (!buttonPrice) {
      // Try to find by class
      const button = document.querySelector(
        `#ProductSubmitButton-${sectionId}`
      );
      if (button) {
        buttonPrice = button.querySelector(".button__price");
      }
    }

    if (!buttonPrice) {
      // Element doesn't exist, let's try to create it
      const button = document.querySelector(
        `#ProductSubmitButton-${sectionId}`
      );
      if (button) {
        const buttonText = button.querySelector(".button__text");
        if (buttonText) {
          // Create the button price element
          buttonPrice = document.createElement("span");
          buttonPrice.className = "button__price";
          buttonPrice.id = `button-price-${sectionId}`;
          buttonPrice.innerHTML = `<span>| </span>${formatMoney(
            price,
            moneyFormat
          )}`;

          // Add it to the button text
          buttonText.appendChild(buttonPrice);
          console.log("Created button price element:", buttonPrice);
        }
      }
    }

    return buttonPrice;
  }

  function generateUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  function updateUniqueProperty(sectionId, isSubscription) {
    const uniqueProperty = document.querySelector(
      `#unique-property-${sectionId}`
    );
    if (!uniqueProperty) {
      console.warn("Unique property field not found");
      return;
    }

    if (isSubscription) {
      uniqueProperty.value = generateUniqueId();
      console.log("Unique property set to:", uniqueProperty.value);
    } else {
      uniqueProperty.value = "";
      console.log("Unique property cleared");
    }
  }

  function initWidget(variants, variantId, moneyFormat, sectionId) {
    const forms = Array.from(
      document.querySelectorAll('form[action$="/cart/add"]')
    );

    const sellingPlanInputs = forms.map(initSellingPlanInput);

    const widget = document.querySelector("#juo-subscription-widget");
    const priceElement = widget.querySelector('[part="subscription-price"]');
    const basePriceElement = widget.querySelector('[part="price price--base"]');
    const comparePriceElement = widget.querySelector('[part="compare-price"]');
    const sellingPlanRadioElements = widget.querySelectorAll(
      '[data-ref="selling-plan"]'
    );

    function getMode() {
      return widget.querySelector('input[name="mode"]:checked').value;
    }

    function getValue() {
      if (getMode() === "otp") {
        return "";
      }

      const selectedRadio = widget.querySelector(
        '[data-ref="selling-plan"]:checked'
      );
      return selectedRadio ? selectedRadio.value : "";
    }

    function populateSellingPlanId() {
      const value = getValue();
      sellingPlanInputs.forEach((sellingPlanInput) => {
        sellingPlanInput.value = value;
      });
    }

    function getActiveVariant() {
      const url = new URL(window.location.href);
      const activeVariantId = url.searchParams.get("variant") || variantId;
      return (
        variants.find(({ id }) => id == activeVariantId) ||
        variants.find(Boolean)
      );
    }

    function updateSaveBadge(comparePrice, price) {
      const saveElement = widget.querySelector('[data-ref="save"]');

      if (saveElement && comparePrice > 0) {
        const percentage = (price / comparePrice) * 100;
        const savings = Math.max(0, 100 - Math.round(percentage));
        saveElement.innerHTML = `${savings}`;
      }
    }

    function updateSellingPlans(
      sellingPlans = [],
      activeVariantId,
      subscriptionSetup
    ) {
      const radioWrapper = widget.querySelector(".j-radio-wrapper");
      if (!radioWrapper) return;

      if (radioWrapper.dataset.activeVariant === String(activeVariantId)) {
        return;
      }

      let html = "";
      sellingPlans.forEach((plan, index) => {
        // Find quantity based on plan index (01, 02, 03)
        const planIndex = String(index + 1).padStart(2, "0"); // Convert 0,1,2 to 01,02,03

        // Safely get values from subscriptionSetup with fallbacks
        const quantityValue =
          (subscriptionSetup && subscriptionSetup[`quantity_${planIndex}`]) ||
          1;
        const subtitle =
          (subscriptionSetup &&
            subscriptionSetup[`option_name_${planIndex}`]) ||
          "";
        const subscriptionFrequency =
          (subscriptionSetup &&
            subscriptionSetup[`subscription_frequency_${planIndex}`]) ||
          0;

        // Ensure quantityValue is a valid number
        const safeQuantityValue = parseInt(quantityValue) || 1;

        // Calculate prices with safe fallbacks
        const price = plan.price * safeQuantityValue;
        const PricePerDay =
          subscriptionFrequency > 0 ? price / subscriptionFrequency : 0;

        // Calculate savings with safe division
        const percentage =
          plan.comparePrice > 0 ? (plan.price / plan.comparePrice) * 100 : 0;
        const save = Math.max(0, `${100 - Math.round(percentage)}`);

        const checked = index === 0 ? "checked" : "";
        html += `
          <label class="j-selling-plan-option">
            <input
              data-ref="selling-plan"
              part="radio"
              type="radio"
              name="selling-plan-radio"
              value="${plan.id}"
              data-quantity-value="${safeQuantityValue}"
              ${checked}
            >
            <div class="j-selling-plan-label-wrapper">
              <span class="j-selling-plan-label">${plan.name}</span>
              <span class="j-selling-plan-price-per-day">${formatMoney(
                PricePerDay,
                moneyFormat
              )}/dzień</span>
            </div>
            <div class="j-selling-plan-subtitle-wrapper">
              <span class="j-selling-plan-subtitle">${subtitle}</span>
            </div>
            <div class="j-selling-plan-price-wrapper">
              <span class="j-selling-plan-price">${formatMoney(
                price,
                moneyFormat
              )}</span>
              <span class="j-selling-plan-save">${save}% taniej</span>
            </div>
          </label>
        `;
      });
      radioWrapper.innerHTML = html;

      if (sellingPlans.length === 0) {
        radioWrapper.innerHTML = "";
        return;
      }

      radioWrapper.dataset.activeVariant = activeVariantId;
      populateSellingPlanId();
    }

    function updateView() {
      const activeVariant = getActiveVariant();
      const selectedRadio = widget.querySelector(
        '[data-ref="selling-plan"]:checked'
      );
      const selectedValue = selectedRadio ? selectedRadio.value : "";
      const allocatedPlan = getAllocatedSellingPlanById(
        activeVariant,
        selectedValue
      );

      updateSellingPlans(
        activeVariant.sellingPlans,
        activeVariant.id,
        activeVariant.subscriptionSetup || {}
      );

      if (allocatedPlan == null) {
        widget?.classList.add("juo-hidden");
        return;
      } else {
        widget?.classList.remove("juo-hidden");
      }

      if (allocatedPlan && allocatedPlan.comparePrice > allocatedPlan.price) {
        updateSaveBadge(allocatedPlan.comparePrice, allocatedPlan.price);
      }

      updatePrice(basePriceElement, activeVariant.price, moneyFormat);
      if (allocatedPlan && allocatedPlan.price) {
        updatePrice(priceElement, allocatedPlan.price, moneyFormat);
        if (
          allocatedPlan.comparePrice &&
          allocatedPlan.price < allocatedPlan.comparePrice &&
          activeVariant.price !== allocatedPlan.price
        ) {
          updatePrice(
            comparePriceElement,
            allocatedPlan.comparePrice,
            moneyFormat
          );
        } else if (comparePriceElement) {
          comparePriceElement.innerHTML = "";
        }
      }

      // Update button price based on selected plan and quantity
      if (
        selectedRadio &&
        getMode() === "subscription" &&
        allocatedPlan &&
        allocatedPlan.price
      ) {
        const quantityValue = selectedRadio.dataset.quantityValue;
        const safeQuantity = parseInt(quantityValue) || 1;
        const totalPrice = allocatedPlan.price * safeQuantity;
        updateButtonPrice(totalPrice, sectionId, moneyFormat);
        updateUniqueProperty(sectionId, true);

        // Ensure quantity is set to subscription plan value
        setQuantity(safeQuantity, sectionId);
      } else if (getMode() === "otp") {
        // For OTP mode, use current quantity from quantity selector
        const quantityForm = document.querySelector(
          `#Quantity-Form-${sectionId}`
        );
        const currentQuantity = quantityForm
          ? parseInt(
              quantityForm.querySelector("input[name='quantity']")?.value
            ) || 1
          : 1;
        console.log("Current quantity:", currentQuantity);
        const totalPrice = activeVariant.price * currentQuantity;
        updateButtonPrice(totalPrice, sectionId, moneyFormat);
        updateUniqueProperty(sectionId, false);
      }
    }

    const collapsibleEl = widget.querySelector(".collapsible");
    const collapsible =
      collapsibleEl == null
        ? null
        : createCollapsible(collapsibleEl, getMode() === "subscription");

    function updateQuantitySelectorVisibility() {
      const productInfo = document.querySelector("#ProductInfo-" + sectionId);
      const productContainer = document.querySelector(
        '[data-section="' + sectionId + '"]'
      );

      if (productInfo || productContainer) {
        const container = productInfo || productContainer;

        if (getMode() === "otp") {
          container.classList.add("otp-mode");
          container.classList.remove("subscription-mode");
        } else {
          container.classList.add("subscription-mode");
          container.classList.remove("otp-mode");

          // Reset quantity to the value from selected subscription plan
          const selectedRadio = widget.querySelector(
            '[data-ref="selling-plan"]:checked'
          );
          if (selectedRadio) {
            const quantityValue = selectedRadio.dataset.quantityValue;
            if (quantityValue) {
              const safeQuantity = parseInt(quantityValue) || 1;
              setQuantity(safeQuantity, sectionId);
            }
          }
        }
      }
    }

    function update() {
      populateSellingPlanId();
      updateView();
      updateQuantitySelectorVisibility();

      if (collapsible) {
        if (getMode() === "subscription") {
          collapsible.open();
        } else {
          collapsible.close();
        }
      }
    }

    update();
    widget.addEventListener("change", update);

    // Initialize quantity on page load
    function initializeQuantity() {
      const selectedRadio = widget.querySelector(
        '[data-ref="selling-plan"]:checked'
      );
      if (selectedRadio && getMode() === "subscription") {
        const quantityValue = selectedRadio.dataset.quantityValue;
        if (quantityValue) {
          const safeQuantity = parseInt(quantityValue) || 1;
          setQuantity(safeQuantity, sectionId);
        }
      } else if (getMode() === "otp") {
        const otpRadio = widget.querySelector(
          'input[name="mode"][value="otp"]'
        );
        const quantityValue = otpRadio?.dataset.quantityValue;
        if (quantityValue) {
          const safeQuantity = parseInt(quantityValue) || 1;
          setQuantity(safeQuantity, sectionId);
        } else {
          // ZMIENIONE: Zamiast setQuantity(1) przywracamy zapisaną wartość
          setQuantity(savedOTPQuantity, sectionId);
        }
      }

      // Initialize button price and unique property
      update();

      // Update quantity selector visibility
      updateQuantitySelectorVisibility();
    }

    // Initialize quantity after a short delay to ensure DOM is ready
    setTimeout(initializeQuantity, 100);

    // Listen for variant changes (common pattern in Shopify themes)
    document.addEventListener("change", function (event) {
      // Check if variant selector changed
      if (
        event.target.matches('input[name="id"]') ||
        event.target.matches('select[name="id"]') ||
        event.target.matches("[data-variant-id]")
      ) {
        // Wait a bit for variant data to update
        setTimeout(initializeQuantity, 200);
      }
    });

    // Also listen for custom variant change events that some themes use
    document.addEventListener("variant:change", function (event) {
      setTimeout(initializeQuantity, 100);
    });

    // Add event listeners to all selling plan radio buttons
    widget.addEventListener("change", (event) => {
      if (event.target.matches('[data-ref="selling-plan"]')) {
        // Check if the clicked selling plan is already checked but subscription mode is not active
        const subscriptionMode = widget.querySelector(
          'input[name="mode"][value="subscription"]'
        );
        const isSubscriptionChecked =
          subscriptionMode && subscriptionMode.checked;
        const isSellingPlanChecked = event.target.checked;

        // If selling plan is checked but subscription mode is not active, activate subscription mode
        if (isSellingPlanChecked && !isSubscriptionChecked) {
          subscriptionMode.click();
        }

        // Update quantity based on selected plan (only if in subscription mode)
        if (getMode() === "subscription") {
          const quantityValue = event.target.dataset.quantityValue;
          if (quantityValue) {
            const safeQuantity = parseInt(quantityValue) || 1;
            setQuantity(safeQuantity, sectionId);
          }
        }
      }

      // ZMIENIONE: Handle OTP - zapisz obecną quantity zamiast resetować do 1
      if (event.target.matches('input[name="mode"][value="otp"]')) {
        // Przywróć zapamiętaną quantity
        setQuantity(savedOTPQuantity, sectionId);
      }

      // ZMIENIONE: Handle subscription - zapisz quantity z OTP przed przejściem
      if (event.target.matches('input[name="mode"][value="subscription"]')) {
        // Zapisz obecną quantity z OTP
        const quantityForm = document.querySelector(`#Quantity-Form-${sectionId}`);
        const currentQuantity = quantityForm
          ? parseInt(quantityForm.querySelector("input[name='quantity']")?.value) || 1
          : 1;
        savedOTPQuantity = currentQuantity;
        
        // Reset quantity to the value from selected subscription plan
        const selectedRadio = widget.querySelector(
          '[data-ref="selling-plan"]:checked'
        );
        if (selectedRadio) {
          const quantityValue = selectedRadio.dataset.quantityValue;
          if (quantityValue) {
            const safeQuantity = parseInt(quantityValue) || 1;
            setQuantity(safeQuantity, sectionId);
          }
        } else {
          // If no plan selected, set to 1
          setQuantity(1, sectionId);
        }
      }
    });

    // Add click event listener to handle clicks on already checked selling plan radios
    widget.addEventListener("click", (event) => {
      if (event.target.matches('[data-ref="selling-plan"]')) {
        // Check if this selling plan is already checked but subscription mode is not active
        const subscriptionMode = widget.querySelector(
          'input[name="mode"][value="subscription"]'
        );
        const isSubscriptionChecked =
          subscriptionMode && subscriptionMode.checked;
        const isSellingPlanChecked = event.target.checked;

        // If selling plan is checked but subscription mode is not active, activate subscription mode
        if (isSellingPlanChecked && !isSubscriptionChecked) {
          subscriptionMode.click();
        }
      }
    });

    // ZMIENIONE: Aktualizuj savedOTPQuantity przy każdej zmianie quantity
    const taioQuantityInput = document.querySelector(".taio-quantity-input");
    if (taioQuantityInput) {
      taioQuantityInput.addEventListener("input", function(event) {
        if (getMode() === "otp") {
          const quantity = parseInt(event.target.value) || 1;
          savedOTPQuantity = quantity;
          console.log("Saved OTP quantity updated to:", savedOTPQuantity);
        }
      });
    }
  }

  function main() {
    if (window.Shopify != null) {
      // eslint-disable-next-line no-inner-declarations
      function init() {
        const [variants, variantId, moneyFormat, sectionId] = JSON.parse(
          document.getElementById("juo-subscription-widget-data")?.innerText ??
            "[]"
        );

        initWidget(variants, variantId, moneyFormat, sectionId);
      }

      if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
      ) {
        init();
      } else {
        document.addEventListener("DOMContentLoaded", init);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
})();